/**
 * Mountain Sanctuary - Product Usage Guide
 * Injects usage/care instructions on product pages.
 * Agarwood: daily 2 sticks, 30-min ritual. Bracelets: wearing & care.
 * 2026-10-10: bracelet guide now renders AFTER the product description
 * (was: right after the buy form) — de-duplicates the bundle gift box
 * and places care instructions after the product intro, per mai.
 */
(function () {
  'use strict';

  // Run only on product pages
  if (!document.body.classList.contains('product') && !window.location.pathname.includes('/products/')) {
    // Fallback: check for product form
    if (!document.querySelector('form[action*="/cart/add"]')) return;
  }

  var AGARWOOD_VARIANT = '67812317986878';

  var GUIDES = {
    agarwood: {
      title: 'How to Use',
      // 中文：使用方法
      body: '<p>Light <strong>two sticks</strong> daily. Let the smoke curl around your bracelet for about <strong>30 minutes</strong> — a quiet moment to clear negative energy and charge your piece with positive energy.</p><p>One box (100g, ~200 sticks) lasts <strong>3+ months</strong> with daily use.</p><p>Each box includes a <strong>QR card</strong> — scan to listen to our Five-Element meditation music while you enjoy your incense.</p>',
    },
    bracelet: {
      title: 'Wearing & Care',
      // 中文：佩戴与保养
      body: '<p>Wear daily to stay connected with its energy. Your bracelet was charged with mountain sunlight, stream water, and temple incense before it reached you.</p><p>To recharge at home, light two sticks of agarwood daily and let the smoke surround the bracelet for 30 minutes.</p><p>Avoid harsh chemicals and prolonged water exposure to keep the stones vibrant.</p>',
    },
    holder: {
      title: 'How to Use',
      body: '<p>Place one incense stick in the holder. Light the tip, let it burn for a few seconds, then gently blow out the flame — the stick will smolder and release fragrant smoke.</p><p>Use with our agarwood for the full daily ritual.</p>',
    },
  };

  function getProductType() {
    // Try to get variant ID from page
    var variantInput = document.querySelector('input[name="id"], select[name="id"]');
    var vid = '';
    if (variantInput) {
      vid = String(variantInput.value).split('/').pop();
    }
    // Also check URL or product JSON
    if (vid === AGARWOOD_VARIANT) return 'agarwood';
    var path = window.location.pathname;
    if (path.includes('agarwood') || path.includes('incense-set')) return 'agarwood';
    if (path.includes('holder')) return 'holder';
    if (path.includes('box')) return 'holder';
    if (path.includes('bracelet')) return 'bracelet';
    return 'bracelet'; // default
  }

  // Anchor for the bracelet care guide: right after the product description block.
  function findDescriptionAnchor() {
    // Primary: the description text block inside product-information (stable block id)
    var desc = document.querySelector('.text-block--text_aEtTtq');
    if (desc) return { parent: desc.parentNode, next: desc.nextSibling };
    // Fallback: any text block containing the bundle gift box markup
    var blocks = document.querySelectorAll('main .text-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].innerHTML.indexOf('Bundle Gift') !== -1) {
        return { parent: blocks[i].parentNode, next: blocks[i].nextSibling };
      }
    }
    return null;
  }

  function inject() {
    var type = getProductType();
    var guide = GUIDES[type] || GUIDES.bracelet;
    if (document.getElementById('ms-usage-guide')) return; // already injected

    var anchor = null;
    if (type === 'bracelet') {
      anchor = findDescriptionAnchor();
    }
    if (!anchor) {
      // Default insertion point: after buy buttons / product form
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      anchor = { parent: form.parentNode, next: form.nextSibling };
    }

    var div = document.createElement('div');
    div.id = 'ms-usage-guide';
    div.style.cssText =
      'margin-top:20px;padding:16px 18px;background:#f7f5f0;border-radius:10px;font-size:14px;line-height:1.65;color:#3a3a3a;';
    div.innerHTML =
      '<div style="font-weight:600;font-size:15px;margin-bottom:8px;color:#1d301d;">' +
      guide.title +
      '</div><div>' +
      guide.body +
      '</div>';

    anchor.parent.insertBefore(div, anchor.next);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(inject, 1200);
    });
  } else {
    setTimeout(inject, 1200);
  }
})();
